class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    if (typeof window.initVariantMatchReveal === 'function') {
      window.initVariantMatchReveal();
    }

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
      
      //Swym Loader
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      
      function swymCallbackFn(swat){
        // your API calls go here
        document.addEventListener("swym:collections-loaded", function(){
          swat.initializeActionButtons("body");
        })
      }
      if(!window.SwymCallbacks){
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(swymCallbackFn);
      //console.log("Swym loaded");
  
      const totalProductsElement = document.getElementById('collectionProductCount');
      const totalProducts = totalProductsElement ? parseInt(totalProductsElement.textContent, 10) : 0;
    
      // Count visible products
      const products = document.querySelectorAll('.product-grid > li');
      const productCount = products.length;
    
      // Display the count somewhere if needed
      const countElement = document.getElementById('product-count');
      if (countElement) {
        countElement.textContent = `${productCount}`;
      }
    
      // Calculate percentage
      const percentage = totalProducts > 0 ? (productCount / totalProducts) * 100 : 0;
    
      // Update progress bar width
      const progressBar = document.getElementById('progress-bar');
      if (progressBar) {
        progressBar.style.width = `${percentage}%`;
      }

          var endlessScroll = new Ajaxinate({
      method: 'scroll', // Change to 'click' if you want a button instead
      container: '.product-grid',
      pagination: '#AjaxinatePagination',
      callback: function(){
        setTimeout(function() {
          const totalProductsElement = document.getElementById('collectionProductCount');
          const totalProducts = totalProductsElement ? parseInt(totalProductsElement.textContent, 10) : 0;
        
          // Count visible products
          const products = document.querySelectorAll('.product-grid > li');
          const productCount = products.length;
        
          // Display the count somewhere if needed
          const countElement = document.getElementById('product-count');
          if (countElement) {
            countElement.textContent = `${productCount}`;
          }
        
          // Calculate percentage
          const percentage = totalProducts > 0 ? (productCount / totalProducts) * 100 : 0;
        
          // Update progress bar width
          const progressBar = document.getElementById('progress-bar');
          if (progressBar) {
            progressBar.style.width = `${percentage}%`;
          }
          //Swym Loader
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            
            function swymCallbackFn(swat){
              // your API calls go here
              document.addEventListener("swym:collections-loaded", function(){
                swat.initializeActionButtons("body");
              })
            }
            if(!window.SwymCallbacks){
              window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push(swymCallbackFn);
            //console.log("Swym loaded Ajax");
        }, 200);
       
      }
      
    });


    const sortDeskButton = document.getElementById("sortDeskButton");
const sortDeskDropdown = document.getElementById("sortDeskDropdown");
const sortOptions = document.querySelectorAll("#sortDeskDropdown li");

let ajaxinateInitialized = false; // Track Ajaxinate state

// Get current URL parameters to highlight the selected option
const urlParams = new URLSearchParams(window.location.search);
const currentSort = urlParams.get("sort_by");

function updateURL(sortBy) {
  const url = new URL(window.location.href);
  url.searchParams.set("sort_by", sortBy);
  window.history.pushState({}, "", url); // Update the browser URL without refreshing
}

// Highlight the current sort option on page load
if (currentSort) {
  sortOptions.forEach(option => {
    if (option.getAttribute("data-sort") === currentSort) {
      option.classList.add("active-sort");
      sortDeskButton.textContent = `Sort By : ${option.textContent}`;
    }
  });
}

// Toggle dropdown on button click
sortDeskButton.addEventListener("click", function () {
  sortDeskDropdown.classList.toggle("sort-hidden");
});

// Close dropdown when clicking outside
document.addEventListener("click", function (event) {
  if (!sortDeskButton.contains(event.target) && !sortDeskDropdown.contains(event.target)) {
    sortDeskDropdown.classList.add("sort-hidden");
  }
});

// Sort option click handler
sortOptions.forEach(item => {
  item.addEventListener("click", function () {
    const selectedSort = this.getAttribute("data-sort");
    sortDeskDropdown.classList.add("sort-hidden");
    sortDeskButton.textContent = `Sort By : ${this.textContent}`;
    updateURL(selectedSort);

    sortOptions.forEach(option => option.classList.remove("active-sort"));
    this.classList.add("active-sort");

    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", selectedSort);

    // Clear existing product grid before replacing with new sorted items
    const oldGrid = document.querySelector(".product-grid");
    if (oldGrid) {
      const newEmptyGrid = oldGrid.cloneNode(false); // clone structure without children
      oldGrid.parentNode.replaceChild(newEmptyGrid, oldGrid);
    }

    fetch(url)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");

        const newProducts = doc.querySelector(".product-grid");
        const newPagination = doc.querySelector("#AjaxinatePagination");

        if (newProducts) {
          document.querySelector(".product-grid").innerHTML = newProducts.innerHTML;

          // Replace or update pagination
          const existingPagination = document.querySelector("#AjaxinatePagination");
          if (existingPagination) {
            existingPagination.remove();
          }

          if (newPagination) {
            const productGrid = document.querySelector(".product-grid");
            if (productGrid) {
              productGrid.insertAdjacentElement("afterend", newPagination);
            }
          }

          // Update product count and progress bar
          const totalProductsElement = document.getElementById('collectionProductCount');
          const totalProducts = totalProductsElement ? parseInt(totalProductsElement.textContent, 10) : 0;

          const products = document.querySelectorAll('.product-grid > li');
          const productCount = products.length;

          const countElement = document.getElementById('product-count');
          if (countElement) {
            countElement.textContent = `${productCount}`;
          }

          const percentage = totalProducts > 0 ? (productCount / totalProducts) * 100 : 0;
          const progressBar = document.getElementById('progress-bar');
          if (progressBar) {
            progressBar.style.width = `${percentage}%`;
          }

          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            
            function swymCallbackFn(swat){
              // your API calls go here
              document.addEventListener("swym:collections-loaded", function(){
                swat.initializeActionButtons("body");
              })
            }
            if(!window.SwymCallbacks){
              window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push(swymCallbackFn);
            //console.log("Swym loaded Ajax");

          updateProductCount(productCount);

          // ✅ Reset and reinitialize Ajaxinate safely
          ajaxinateInitialized = false;

          setTimeout(() => {
            if (document.querySelector("#AjaxinatePagination a")) {
              initializeAjaxinate();
              //console.log("Ajaxinate reinitialized after sort");
            } else {
              //console.log("No pagination link — Ajaxinate not reinitialized");
            }
          }, 200);
        }
      })
      .catch(error => console.error("Error fetching sorted products:", error));
  });
});

function initializeAjaxinate() {
  if (ajaxinateInitialized) return;
  ajaxinateInitialized = true;

  new Ajaxinate({
    method: 'scroll',
    container: '.product-grid',
    pagination: '#AjaxinatePagination',
    callback: function () {
      setTimeout(() => {
        const currentCount = document.querySelectorAll(".product-grid .grid__item").length;
        updateProductCount(currentCount);
        // updateProductCountsText();
        const totalProductsElement = document.getElementById('collectionProductCount');
          const totalProducts = totalProductsElement ? parseInt(totalProductsElement.textContent, 10) : 0;

          const products = document.querySelectorAll('.product-grid > li');
          const productCount = products.length;

          const countElement = document.getElementById('product-count');
          if (countElement) {
            countElement.textContent = `${productCount}`;
          }

          const percentage = totalProducts > 0 ? (productCount / totalProducts) * 100 : 0;
          const progressBar = document.getElementById('progress-bar');
          if (progressBar) {
            progressBar.style.width = `${percentage}%`;
          }

        const nextLink = document.querySelector("#AjaxinatePagination a");
        if (!nextLink) {
          document.getElementById("AjaxinatePagination")?.remove();
          ajaxinateInitialized = false; // Reset for future scrolls
          //console.log("No more pages — scroll pagination removed.");
          //console.log("JS");
        }
        //Swym Loader
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            
            function swymCallbackFn(swat){
              // your API calls go here
              document.addEventListener("swym:collections-loaded", function(){
                swat.initializeActionButtons("body");
              })
            }
            if(!window.SwymCallbacks){
              window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push(swymCallbackFn);
            //console.log("Swym loaded Ajax");
      }, 200);
    }
  });
}

// Utility to update product count — define this if not already available
function updateProductCount(count) {
  const countElement = document.getElementById("product-count");
  if (countElement) {
    countElement.textContent = `${count}`;
  }
}

      
   
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (!sourceFacetsList || !targetFacetsList) return;

    const targetCustomElement = targetFacetsList.closest(
      'needle-length-slider, suture-size-slider, absorbability-toggle'
    );
    const sourceCustomElement = sourceFacetsList.closest(
      'needle-length-slider, suture-size-slider, absorbability-toggle'
    );

    if (targetCustomElement && sourceCustomElement) {
      targetCustomElement.outerHTML = sourceCustomElement.outerHTML;
    } else {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class NeedleLengthSlider extends HTMLElement {
  connectedCallback() {
    this.checkboxes = Array.from(this.querySelectorAll('input[type="checkbox"]'));
    if (this.checkboxes.length < 2) return;

    // Every possible length value stays in the scale, enabled or not, so the
    // slider's endpoints and spacing never shift depending on which other
    // filters are active. Values with 0 current matches render greyed-out and
    // are skipped when placing a handle — disabled checkboxes never submit
    // with the form regardless of their checked state, so a handle landing on
    // one would look like nothing happened.
    this.stops = this.checkboxes
      .map((input) => ({ input, num: parseFloat(input.value), raw: input.value }))
      .sort((a, b) => a.num - b.num);

    if (this.stops.length < 1) return;

    this.maxIndex = this.stops.length - 1;

    const activeIndexes = this.stops
      .map((stop, i) => (stop.input.checked ? i : null))
      .filter((i) => i !== null);

    // Each handle tracks its own index independently, with no clamping against
    // the other handle. This is what prevents a handle from getting stuck when
    // both start out pinned to the same stop. Low/high are only derived when
    // needed, for rendering the fill/labels and for committing the filter.
    this.handleAIndex = activeIndexes.length ? Math.min(...activeIndexes) : 0;
    this.handleBIndex = activeIndexes.length ? Math.max(...activeIndexes) : this.maxIndex;

    // A commit fully reloads this element from the server, so in-memory
    // state from a first click can't survive to pair with a second click —
    // re-deriving it here is what makes that survive. Exactly one active
    // value means the filter is currently a single collapsed selection
    // (not the full range, not an already-formed multi-value range), so
    // the next track click should pair with it, not start fresh.
    this.pendingSingleIndex = activeIndexes.length === 1 ? activeIndexes[0] : null;

    this.buildUI();
    this.render();
  }

  buildUI() {
    const wrapper = document.createElement('div');
    wrapper.className = 'needle-length-slider__ui';
    wrapper.innerHTML = `
      <div class="needle-length-slider__labels">
        <span class="needle-length-slider__label needle-length-slider__label--low"></span>
        <span class="needle-length-slider__label needle-length-slider__label--high"></span>
      </div>
      <div class="needle-length-slider__track">
        <div class="needle-length-slider__range"></div>
        <button type="button" class="needle-length-slider__handle needle-length-slider__handle--low" role="slider" aria-label="Needle length handle A"></button>
        <button type="button" class="needle-length-slider__handle needle-length-slider__handle--high" role="slider" aria-label="Needle length handle B"></button>
      </div>
    `;
    this.prepend(wrapper);

    this.track = wrapper.querySelector('.needle-length-slider__track');
    this.handleA = wrapper.querySelector('.needle-length-slider__handle--low');
    this.handleB = wrapper.querySelector('.needle-length-slider__handle--high');
    this.rangeFill = wrapper.querySelector('.needle-length-slider__range');
    this.lowLabel = wrapper.querySelector('.needle-length-slider__label--low');
    this.highLabel = wrapper.querySelector('.needle-length-slider__label--high');

    this.handleA.addEventListener('pointerdown', (e) => this.startDrag(e, 'a'));
    this.handleB.addEventListener('pointerdown', (e) => this.startDrag(e, 'b'));
    this.handleA.addEventListener('keydown', (e) => this.onKeydown(e, 'a'));
    this.handleB.addEventListener('keydown', (e) => this.onKeydown(e, 'b'));
    this.track.addEventListener('click', (e) => this.onTrackClick(e));
  }

  // Walks outward from a raw index to the nearest stop that isn't disabled,
  // so a drag can never park a handle on a value with 0 current matches.
  findNearestEnabledIndex(rawIndex) {
    const clamped = Math.min(Math.max(rawIndex, 0), this.maxIndex);
    if (this.stops[clamped] && !this.stops[clamped].input.disabled) return clamped;
    for (let offset = 1; offset <= this.maxIndex; offset++) {
      const lower = clamped - offset;
      const upper = clamped + offset;
      if (lower >= 0 && this.stops[lower] && !this.stops[lower].input.disabled) return lower;
      if (upper <= this.maxIndex && this.stops[upper] && !this.stops[upper].input.disabled) return upper;
    }
    return clamped;
  }

  // Same idea for arrow-key stepping — skip past disabled stops in the
  // direction pressed rather than landing on one.
  stepToEnabledIndex(fromIndex, delta) {
    let idx = fromIndex + delta;
    while (idx >= 0 && idx <= this.maxIndex && this.stops[idx].input.disabled) {
      idx += delta;
    }
    if (idx < 0 || idx > this.maxIndex || this.stops[idx].input.disabled) return fromIndex;
    return idx;
  }

  // First click on the track collapses both handles onto that one stop and
  // commits it as a real single-value selection. A second click elsewhere
  // pairs with the first to form a range. A third click starts a fresh
  // single-value cycle rather than adding a third point. Clicks on a handle
  // itself are excluded here — those go through startDrag/onDrag untouched.
  onTrackClick(event) {
    if (event.target === this.handleA || event.target === this.handleB) return;

    const rect = this.track.getBoundingClientRect();
    const ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
    const rawIndex = Math.round(ratio * this.maxIndex);
    const index = this.findNearestEnabledIndex(rawIndex);

    if (this.pendingSingleIndex === null) {
      this.handleAIndex = index;
      this.handleBIndex = index;
      this.pendingSingleIndex = index;
    } else {
      this.handleAIndex = this.pendingSingleIndex;
      this.handleBIndex = index;
      this.pendingSingleIndex = null;
    }

    this.render();
    this.commit();
  }

  startDrag(event, which) {
    event.preventDefault();
    this.pendingSingleIndex = null;
    const handle = which === 'a' ? this.handleA : this.handleB;
    handle.setPointerCapture(event.pointerId);
    this.dragging = which;

    const onMove = (moveEvent) => this.onDrag(moveEvent);
    const onUp = () => {
      handle.releasePointerCapture(event.pointerId);
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      this.dragging = null;
      this.commit();
    };

    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
  }

  onDrag(event) {
    if (!this.dragging) return;
    const rect = this.track.getBoundingClientRect();
    const ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
    const rawIndex = Math.round(ratio * this.maxIndex);
    const index = this.findNearestEnabledIndex(rawIndex);

    if (this.dragging === 'a') {
      this.handleAIndex = index;
    } else {
      this.handleBIndex = index;
    }
    this.render();
  }

  onKeydown(event, which) {
    let delta = 0;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') delta = -1;
    if (event.key === 'ArrowRight' || event.key === 'ArrowUp') delta = 1;
    if (delta === 0) return;
    event.preventDefault();

    if (which === 'a') {
      this.handleAIndex = this.stepToEnabledIndex(this.handleAIndex, delta);
    } else {
      this.handleBIndex = this.stepToEnabledIndex(this.handleBIndex, delta);
    }
    this.render();
    this.commit();
  }

  // Mirrors the ".0" trimming already applied to needle-length pill labels
  // elsewhere in facets.liquid, so "36.0" reads as "36".
  formatLabel(stop) {
    return stop.raw.replace(/\.0$/, '');
  }

  // Overwrites the server-rendered "(N)" count next to the filter name with
  // the actual selected range, since a raw count of swept values (e.g. "(4)"
  // for a 7-0–4-0 sweep) reads as confusing. Desktop vertical layout only —
  // mobile doesn't render this count span, so this safely no-ops there.
  updateSelectedCount(lowIndex, highIndex, isFullRange) {
    const details = this.closest('details');
    if (!details) return;
    const countEl = details.querySelector('.facets__summary-label .facets__selected');
    if (!countEl) return;

    if (isFullRange) {
      countEl.textContent = '';
      countEl.classList.add('hidden');
      return;
    }

    countEl.classList.remove('hidden');
    if (lowIndex === highIndex) {
      countEl.textContent = `(${this.formatLabel(this.stops[lowIndex])})`;
    } else {
      countEl.textContent = `(${this.formatLabel(this.stops[lowIndex])}\u2013${this.formatLabel(this.stops[highIndex])})`;
    }
  }

  render() {
    const lowIndex = Math.min(this.handleAIndex, this.handleBIndex);
    const highIndex = Math.max(this.handleAIndex, this.handleBIndex);
    const isFullRange = lowIndex === 0 && highIndex === this.maxIndex;

    const aPercent = this.maxIndex ? (this.handleAIndex / this.maxIndex) * 100 : 0;
    const bPercent = this.maxIndex ? (this.handleBIndex / this.maxIndex) * 100 : 0;
    this.handleA.style.left = `${aPercent}%`;
    this.handleB.style.left = `${bPercent}%`;

    const lowPercent = this.maxIndex ? (lowIndex / this.maxIndex) * 100 : 0;
    const highPercent = this.maxIndex ? (highIndex / this.maxIndex) * 100 : 0;
    this.rangeFill.style.left = `${lowPercent}%`;
    this.rangeFill.style.width = `${highPercent - lowPercent}%`;

    this.lowLabel.style.left = `${lowPercent}%`;
    this.highLabel.style.left = `${highPercent}%`;
    this.lowLabel.textContent = this.formatLabel(this.stops[lowIndex]);
    this.highLabel.textContent = lowIndex === highIndex ? '' : this.formatLabel(this.stops[highIndex]);

    this.handleA.setAttribute('aria-valuenow', this.stops[this.handleAIndex].num);
    this.handleB.setAttribute('aria-valuenow', this.stops[this.handleBIndex].num);

    this.updateSelectedCount(lowIndex, highIndex, isFullRange);
  }

  commit() {
    const lowIndex = Math.min(this.handleAIndex, this.handleBIndex);
    const highIndex = Math.max(this.handleAIndex, this.handleBIndex);
    const isFullRange = lowIndex === 0 && highIndex === this.maxIndex;

    this.stops.forEach((stop, i) => {
      stop.input.checked = !isFullRange && i >= lowIndex && i <= highIndex && !stop.input.disabled;
    });

    this.stops[0].input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

customElements.define('needle-length-slider', NeedleLengthSlider);

class SutureSizeSlider extends HTMLElement {
  connectedCallback() {
    this.checkboxes = Array.from(this.querySelectorAll('input[type="checkbox"]'));
    if (this.checkboxes.length < 2) return;

    const CLINICAL_ORDER = ['9-0', '8-0', '7-0', '6-0', '5-0', '4-0', '3-0', '2-0', '0', '1', '2', '5'];

    // Every clinical size stays in the scale, enabled or not, so the slider's
    // endpoints and spacing are identical no matter which other filters are
    // active. Sizes with 0 current matches render greyed-out and are skipped
    // when placing a handle — disabled checkboxes never submit with the form
    // regardless of their checked state, so a handle landing on one would
    // look like nothing happened.
    this.stops = this.checkboxes
      .map((input) => ({ input, label: input.value }))
      .sort((a, b) => {
        const ai = CLINICAL_ORDER.indexOf(a.label);
        const bi = CLINICAL_ORDER.indexOf(b.label);
        return (ai === -1 ? CLINICAL_ORDER.length : ai) - (bi === -1 ? CLINICAL_ORDER.length : bi);
      });

    if (this.stops.length < 1) return;
    this.maxIndex = this.stops.length - 1;

    const activeIndexes = this.stops
      .map((stop, i) => (stop.input.checked ? i : null))
      .filter((i) => i !== null);

    this.handleAIndex = activeIndexes.length ? Math.min(...activeIndexes) : 0;
    this.handleBIndex = activeIndexes.length ? Math.max(...activeIndexes) : this.maxIndex;

    // A commit fully reloads this element from the server, so in-memory
    // state from a first click can't survive to pair with a second click —
    // re-deriving it here is what makes that survive. Exactly one active
    // value means the filter is currently a single collapsed selection
    // (not the full range, not an already-formed multi-value range), so
    // the next track click should pair with it, not start fresh.
    this.pendingSingleIndex = activeIndexes.length === 1 ? activeIndexes[0] : null;

    this.buildUI();
    this.render();
  }

  buildUI() {
    const wrapper = document.createElement('div');
    wrapper.className = 'needle-length-slider__ui';
    wrapper.innerHTML = `
      <div class="needle-length-slider__labels">
        <span class="needle-length-slider__label needle-length-slider__label--low"></span>
        <span class="needle-length-slider__label needle-length-slider__label--high"></span>
      </div>
      <div class="needle-length-slider__track">
        <div class="needle-length-slider__range"></div>
        <button type="button" class="needle-length-slider__handle needle-length-slider__handle--low" role="slider" aria-label="Suture size handle A"></button>
        <button type="button" class="needle-length-slider__handle needle-length-slider__handle--high" role="slider" aria-label="Suture size handle B"></button>
      </div>
      <div class="needle-length-slider__ticks"></div>
    `;
    this.prepend(wrapper);

    this.track = wrapper.querySelector('.needle-length-slider__track');
    this.handleA = wrapper.querySelector('.needle-length-slider__handle--low');
    this.handleB = wrapper.querySelector('.needle-length-slider__handle--high');
    this.rangeFill = wrapper.querySelector('.needle-length-slider__range');
    this.lowLabel = wrapper.querySelector('.needle-length-slider__label--low');
    this.highLabel = wrapper.querySelector('.needle-length-slider__label--high');
    this.ticksContainer = wrapper.querySelector('.needle-length-slider__ticks');

    this.handleA.addEventListener('pointerdown', (e) => this.startDrag(e, 'a'));
    this.handleB.addEventListener('pointerdown', (e) => this.startDrag(e, 'b'));
    this.handleA.addEventListener('keydown', (e) => this.onKeydown(e, 'a'));
    this.handleB.addEventListener('keydown', (e) => this.onKeydown(e, 'b'));
    this.track.addEventListener('click', (e) => this.onTrackClick(e));

    this.buildTicks();
  }

  buildTicks() {
    // Every stop still gets a physical tick mark, so the scale itself always
    // shows all 12 positions. Text labels stay capped at 6 (bumped from the
    // old 4, since there are always 12 fixed positions to choose from now)
    // to avoid crowding a ~250px sidebar — but which 6 are labelled is now a
    // fixed set of indices, not dependent on which sizes are disabled, so
    // the labels never jump around like they used to.
    const labelCount = Math.min(6, this.stops.length);
    const labelledIndexes = new Set();
    for (let n = 0; n < labelCount; n++) {
      const idx = this.maxIndex ? Math.round((n / (labelCount - 1)) * this.maxIndex) : 0;
      labelledIndexes.add(idx);
    }

    this.stops.forEach((stop, i) => {
      const percent = this.maxIndex ? (i / this.maxIndex) * 100 : 0;
      const tick = document.createElement('span');
      tick.className = 'needle-length-slider__tick';
      if (stop.input.disabled) tick.classList.add('needle-length-slider__tick--disabled');
      tick.style.left = `${percent}%`;
      this.ticksContainer.appendChild(tick);

      if (labelledIndexes.has(i)) {
        const tickLabel = document.createElement('span');
        tickLabel.className = 'needle-length-slider__tick-label';
        if (stop.input.disabled) tickLabel.classList.add('needle-length-slider__tick-label--disabled');
        tickLabel.style.left = `${percent}%`;
        tickLabel.textContent = stop.label;
        this.ticksContainer.appendChild(tickLabel);
      }
    });
  }

  // Walks outward from a raw index to the nearest stop that isn't disabled,
  // so a drag can never park a handle on a size with 0 current matches.
  findNearestEnabledIndex(rawIndex) {
    const clamped = Math.min(Math.max(rawIndex, 0), this.maxIndex);
    if (this.stops[clamped] && !this.stops[clamped].input.disabled) return clamped;
    for (let offset = 1; offset <= this.maxIndex; offset++) {
      const lower = clamped - offset;
      const upper = clamped + offset;
      if (lower >= 0 && this.stops[lower] && !this.stops[lower].input.disabled) return lower;
      if (upper <= this.maxIndex && this.stops[upper] && !this.stops[upper].input.disabled) return upper;
    }
    return clamped;
  }

  // Same idea for arrow-key stepping — skip past disabled stops in the
  // direction pressed rather than landing on one.
  stepToEnabledIndex(fromIndex, delta) {
    let idx = fromIndex + delta;
    while (idx >= 0 && idx <= this.maxIndex && this.stops[idx].input.disabled) {
      idx += delta;
    }
    if (idx < 0 || idx > this.maxIndex || this.stops[idx].input.disabled) return fromIndex;
    return idx;
  }

  // First click on the track collapses both handles onto that one stop and
  // commits it as a real single-value selection. A second click elsewhere
  // pairs with the first to form a range. A third click starts a fresh
  // single-value cycle rather than adding a third point. Clicks on a handle
  // itself are excluded here — those go through startDrag/onDrag untouched.
  onTrackClick(event) {
    if (event.target === this.handleA || event.target === this.handleB) return;

    const rect = this.track.getBoundingClientRect();
    const ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
    const rawIndex = Math.round(ratio * this.maxIndex);
    const index = this.findNearestEnabledIndex(rawIndex);

    if (this.pendingSingleIndex === null) {
      this.handleAIndex = index;
      this.handleBIndex = index;
      this.pendingSingleIndex = index;
    } else {
      this.handleAIndex = this.pendingSingleIndex;
      this.handleBIndex = index;
      this.pendingSingleIndex = null;
    }

    this.render();
    this.commit();
  }

  startDrag(event, which) {
    event.preventDefault();
    this.pendingSingleIndex = null;
    const handle = which === 'a' ? this.handleA : this.handleB;
    handle.setPointerCapture(event.pointerId);
    this.dragging = which;

    const onMove = (moveEvent) => this.onDrag(moveEvent);
    const onUp = () => {
      handle.releasePointerCapture(event.pointerId);
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      this.dragging = null;
      this.commit();
    };

    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
  }

  onDrag(event) {
    if (!this.dragging) return;
    const rect = this.track.getBoundingClientRect();
    const ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
    const rawIndex = Math.round(ratio * this.maxIndex);
    const index = this.findNearestEnabledIndex(rawIndex);
    if (this.dragging === 'a') {
      this.handleAIndex = index;
    } else {
      this.handleBIndex = index;
    }
    this.render();
  }

  onKeydown(event, which) {
    let delta = 0;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') delta = -1;
    if (event.key === 'ArrowRight' || event.key === 'ArrowUp') delta = 1;
    if (delta === 0) return;
    event.preventDefault();

    if (which === 'a') {
      this.handleAIndex = this.stepToEnabledIndex(this.handleAIndex, delta);
    } else {
      this.handleBIndex = this.stepToEnabledIndex(this.handleBIndex, delta);
    }
    this.render();
    this.commit();
  }

  // Overwrites the server-rendered "(N)" count next to the filter name with
  // the actual selected range, since a raw count of swept values (e.g. "(4)"
  // for a 7-0–4-0 sweep) reads as confusing. Desktop vertical layout only —
  // mobile doesn't render this count span, so this safely no-ops there.
  updateSelectedCount(lowIndex, highIndex, isFullRange) {
    const details = this.closest('details');
    if (!details) return;
    const countEl = details.querySelector('.facets__summary-label .facets__selected');
    if (!countEl) return;

    if (isFullRange) {
      countEl.textContent = '';
      countEl.classList.add('hidden');
      return;
    }

    countEl.classList.remove('hidden');
    if (lowIndex === highIndex) {
      countEl.textContent = `(${this.stops[lowIndex].label})`;
    } else {
      countEl.textContent = `(${this.stops[lowIndex].label} to ${this.stops[highIndex].label})`;
    }
  }

  render() {
    const lowIndex = Math.min(this.handleAIndex, this.handleBIndex);
    const highIndex = Math.max(this.handleAIndex, this.handleBIndex);
    const isFullRange = lowIndex === 0 && highIndex === this.maxIndex;

    const aPercent = this.maxIndex ? (this.handleAIndex / this.maxIndex) * 100 : 0;
    const bPercent = this.maxIndex ? (this.handleBIndex / this.maxIndex) * 100 : 0;
    this.handleA.style.left = `${aPercent}%`;
    this.handleB.style.left = `${bPercent}%`;

    const lowPercent = this.maxIndex ? (lowIndex / this.maxIndex) * 100 : 0;
    const highPercent = this.maxIndex ? (highIndex / this.maxIndex) * 100 : 0;
    this.rangeFill.style.left = `${lowPercent}%`;
    this.rangeFill.style.width = `${highPercent - lowPercent}%`;

    this.lowLabel.style.left = `${lowPercent}%`;
    this.highLabel.style.left = `${highPercent}%`;
    this.lowLabel.textContent = this.stops[lowIndex].label;
    this.highLabel.textContent = lowIndex === highIndex ? '' : this.stops[highIndex].label;

    this.handleA.setAttribute('aria-valuenow', this.stops[this.handleAIndex].label);
    this.handleB.setAttribute('aria-valuenow', this.stops[this.handleBIndex].label);

    this.updateSelectedCount(lowIndex, highIndex, isFullRange);
  }

  commit() {
    const lowIndex = Math.min(this.handleAIndex, this.handleBIndex);
    const highIndex = Math.max(this.handleAIndex, this.handleBIndex);
    const isFullRange = lowIndex === 0 && highIndex === this.maxIndex;

    this.stops.forEach((stop, i) => {
      stop.input.checked = !isFullRange && i >= lowIndex && i <= highIndex && !stop.input.disabled;
    });

    this.stops[0].input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

customElements.define('suture-size-slider', SutureSizeSlider);

class AbsorbabilityToggle extends HTMLElement {
  connectedCallback() {
    this.checkboxes = Array.from(this.querySelectorAll('input[type="checkbox"]'));
    if (this.checkboxes.length < 1) return;

    this.buildUI();
  }

  buildUI() {
    const wrapper = document.createElement('div');
    wrapper.className = 'absorbability-toggle__ui';

    this.checkboxes.forEach((input) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'absorbability-toggle__button';

      // The count is already rendered by Liquid into the (now-hidden)
      // checkbox label as "Label (count)" — read it from there instead
      // of duplicating that logic here, so it stays in sync automatically
      // whenever the filter panel re-renders after another filter changes.
      const label = input.closest('label');
      const textSpan = label ? label.querySelector('.facet-checkbox__text') : null;
      const countMatch = textSpan ? textSpan.textContent.match(/\((\d+)\)/) : null;

      const labelSpan = document.createElement('span');
      labelSpan.className = 'absorbability-toggle__label';
      labelSpan.textContent = input.value;
      button.appendChild(labelSpan);

      if (countMatch) {
        const countSpan = document.createElement('span');
        countSpan.className = 'absorbability-toggle__count';
        countSpan.textContent = `(${countMatch[1]})`;
        button.appendChild(countSpan);
      }

      button.disabled = input.disabled;
      button.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
      button.classList.toggle('absorbability-toggle__button--active', input.checked);

      button.addEventListener('click', () => {
        input.checked = !input.checked;
        button.classList.toggle('absorbability-toggle__button--active', input.checked);
        button.setAttribute('aria-pressed', input.checked ? 'true' : 'false');

        // Same bubbling 'input' event pattern as the sliders — rides the
        // existing FacetFiltersForm debounced listener, no separate fetch.
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });

      wrapper.appendChild(button);
    });

    this.prepend(wrapper);
  }
}

customElements.define('absorbability-toggle', AbsorbabilityToggle);